import { FolderIdentification } from './folder-identification';

export class FolderMergeNotification {
    public viewId: number;
    public targetFolderId: string;
    public mergedFolderIdentifications: FolderIdentification[];

    public static fromJson(other: any): FolderMergeNotification {
        const instance = new FolderMergeNotification();
        instance.viewId = other.ViewId;
        instance.targetFolderId = other.TargetFolderId;
        instance.mergedFolderIdentifications = other.MergedFolderIdentifications;
        return instance;
    }
}
